(() => {
  if (window.PrintMyPadAnnouncementBar) return;

  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia(REDUCED_MOTION_QUERY).matches;
  }

  function buildMarquee(bar) {
    const marquee = bar.querySelector("[data-marquee]");
    const track = bar.querySelector("[data-track]");
    const sequence = bar.querySelector("[data-seq]");

    if (!marquee || !track || !sequence || prefersReducedMotion()) return;

    if (!sequence.dataset.originalHtml) {
      sequence.dataset.originalHtml = sequence.innerHTML;
    }

    const rebuild = () => {
      sequence.innerHTML = sequence.dataset.originalHtml;

      const requiredWidth = marquee.offsetWidth;
      if (!requiredWidth) return;

      while (sequence.scrollWidth < requiredWidth) {
        sequence.insertAdjacentHTML("beforeend", sequence.dataset.originalHtml);
      }

      const clone = track.querySelector("[data-seq-clone]");
      if (clone) clone.remove();

      const nextClone = sequence.cloneNode(true);
      nextClone.setAttribute("data-seq-clone", "");
      nextClone.setAttribute("aria-hidden", "true");
      track.appendChild(nextClone);
    };

    rebuild();

    if (bar._announcementResizeHandler) {
      window.removeEventListener("resize", bar._announcementResizeHandler);
    }

    let resizeFrame = 0;
    bar._announcementResizeHandler = () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(rebuild);
    };

    window.addEventListener("resize", bar._announcementResizeHandler);
  }

  function startCountdown(bar) {
    const countdown = bar.querySelector("[data-countdown]");
    if (!countdown) return;

    const dateStr = countdown.getAttribute("data-countdown-date");
    const timeStr = countdown.getAttribute("data-countdown-time") || "00:00:00";
    const expiredText = countdown.getAttribute("data-expired-text") || "Expired";
    const hideOnExpire = countdown.getAttribute("data-hide-on-expire") === "true";

    if (!dateStr) return;

    const dateParts = dateStr.split("-").map(Number);
    const timeParts = timeStr.split(":").map(Number);
    if (dateParts.length < 3) return;

    const target = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2],
      timeParts[0] || 0,
      timeParts[1] || 0,
      timeParts[2] || 0
    );

    if (Number.isNaN(target.getTime())) return;

    if (bar._announcementCountdownTimer) {
      clearInterval(bar._announcementCountdownTimer);
    }

    const pad = (value) => String(Math.max(0, value)).padStart(2, "0");

    const update = () => {
      const distance = target.getTime() - Date.now();

      if (distance <= 0) {
        if (hideOnExpire) {
          bar.style.display = "none";
        } else {
          countdown.textContent = expiredText;
        }

        clearInterval(bar._announcementCountdownTimer);
        return;
      }

      const units = {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      };

      Object.entries(units).forEach(([key, value]) => {
        const el = countdown.querySelector(`[data-value="${key}"]`);
        if (el) el.textContent = pad(value);
      });
    };

    update();
    bar._announcementCountdownTimer = window.setInterval(update, 1000);
  }

  function init(scope = document) {
    scope
      .querySelectorAll("[data-announcement-bar]")
      .forEach((bar) => {
        if (bar.dataset.announcementInitialized === "true") return;
        bar.dataset.announcementInitialized = "true";
        buildMarquee(bar);
        startCountdown(bar);
      });
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:block:select", (event) => init(event.target));

  window.PrintMyPadAnnouncementBar = { init };
  init();
})();
